import { AutogenModelFreightMatchingUsers, AutogenRowFreightMatchingUsers } from "./autogen/AutogenModelFreightMatchingUsers";

export class ModelFreightMatchingUsers extends AutogenModelFreightMatchingUsers<RowFreightMatchingUsers> {
	constructor() {
		super(RowFreightMatchingUsers);
	}
}

export class RowFreightMatchingUsers extends AutogenRowFreightMatchingUsers {
}